(function () {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  function setupScrollArea(root) {
    const track = root.querySelector('[data-fleece-track]');
    const previous = root.querySelector('[data-fleece-previous]');
    const next = root.querySelector('[data-fleece-next]');
    if (!track || !previous || !next) return;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      previous.disabled = max < 2 || track.scrollLeft <= 2;
      next.disabled = max < 2 || track.scrollLeft >= max - 2;
    };
    const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .82, 240), behavior: 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function setupProductTabs(root) {
    const tabs = root.querySelectorAll('[data-fleece-filter]');
    const cards = root.querySelectorAll('[data-fleece-category]');
    if (!tabs.length || !cards.length) return;
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const filter = tab.dataset.fleeceFilter;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      cards.forEach((card) => { card.hidden = filter !== 'all' && card.dataset.fleeceCategory !== filter; });
    }));
  }

  function setupHeader(root) {
    const toggle = root.querySelector('[data-fleece-menu-toggle]');
    const drawer = root.querySelector('[data-fleece-drawer]');
    if (toggle && drawer) {
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };
      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        drawer.querySelector('a,button')?.focus();
      };
      toggle.addEventListener('click', () => drawer.classList.contains('is-open') ? close() : open());
      drawer.querySelectorAll('[data-fleece-menu-close]').forEach((item) => item.addEventListener('click', close));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    }

    // Desktop: keep # parent from navigating; toggle open on click (hover also works via CSS)
    root.querySelectorAll('[data-fleece-nav-item]').forEach((item) => {
      const trigger = item.querySelector('[data-fleece-nav-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', (event) => {
        const href = trigger.getAttribute('href') || '';
        if (href === '#' || href === '' || href.endsWith('#')) {
          event.preventDefault();
          const openNow = !item.classList.contains('is-open');
          root.querySelectorAll('[data-fleece-nav-item].is-open').forEach((other) => {
            if (other !== item) {
              other.classList.remove('is-open');
              other.querySelector('[data-fleece-nav-trigger]')?.setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.toggle('is-open', openNow);
          trigger.setAttribute('aria-expanded', String(openNow));
        }
      });
    });
    document.addEventListener('click', (event) => {
      if (root.contains(event.target) && event.target.closest('[data-fleece-nav-item]')) return;
      root.querySelectorAll('[data-fleece-nav-item].is-open').forEach((item) => {
        item.classList.remove('is-open');
        item.querySelector('[data-fleece-nav-trigger]')?.setAttribute('aria-expanded', 'false');
      });
    });

    // Mobile drawer: expand nested collection list
    root.querySelectorAll('[data-fleece-mobile-item]').forEach((item) => {
      const trigger = item.querySelector('[data-fleece-mobile-trigger]');
      const submenu = item.querySelector('.fleece-mobile-nav__submenu');
      if (!trigger || !submenu) return;
      trigger.addEventListener('click', () => {
        const openNow = !item.classList.contains('is-open');
        item.classList.toggle('is-open', openNow);
        trigger.setAttribute('aria-expanded', String(openNow));
        submenu.hidden = !openNow;
      });
    });
  }

  function init(scope) {
    scope.querySelectorAll('[data-fleece-carousel]').forEach(setupScrollArea);
    scope.querySelectorAll('[data-fleece-products]').forEach(setupProductTabs);
    scope.querySelectorAll('[data-fleece-header]').forEach(setupHeader);
  }

  ready(() => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
